"use client";

import { c as _c } from "react/compiler-runtime";
import { ModelSelector } from "@/components/model-selector";
import { LanguageSwitcher } from "@/components/playground/language-switcher";
import { McpServersDialog } from "@/components/playground/mcp-servers-dialog";
import { ShareChatDialog } from "@/components/playground/share-chat-dialog";
import { TempChatSwitcher } from "@/components/playground/temp-chat-switcher";
import { Label } from "@/components/ui/label";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Switch } from "@/components/ui/switch";
import { TooltipProvider } from "@/components/ui/tooltip";
import type { McpServer } from "@/hooks/useMcpServers";
import type { ApiModel, ApiProvider } from "@/lib/fetch-models";
import type { Organization } from "@/lib/types";
interface ChatHeaderProps {
  models: ApiModel[];
  providers: ApiProvider[];
  selectedModel: string;
  setSelectedModel: (model: string) => void;
  comparisonEnabled: boolean;
  onComparisonEnabledChange: (enabled: boolean) => void;
  hideCompare?: boolean;
  showGlobalModelSelector: boolean;
  allowAutoSelectProvider?: boolean;
  requiresProviderSelection?: boolean;
  // MCP servers props
  mcpServers: McpServer[];
  onAddMcpServer: (server: Omit<McpServer, "id">) => McpServer;
  onUpdateMcpServer: (id: string, updates: Partial<Omit<McpServer, "id">>) => void;
  onRemoveMcpServer: (id: string) => void;
  onToggleMcpServer: (id: string) => void;
  isTemporaryChat: boolean;
  onToggleTemporaryChat: () => void;
  showTemporaryChatSwitcher: boolean;
  isTemporaryChatToggleDisabled: boolean;
  hasTemporaryMessages: boolean;
  currentChatId: string | null;
  isShareChatDisabled?: boolean;
  showMcpServers?: boolean;
  showShareChat?: boolean;
  showComparisonMode?: boolean;
  showLanguageSelector?: boolean;
  shareId: string | null;
  orgShares: Array<{
    id: string;
    organizationId: string;
  }>;
  organizations: Organization[];
  chatTitle?: string | null;
  previewPrompt?: string | null;
}
export const ChatHeader = t0 => {
  const $ = _c(54);
  const {
    models,
    providers,
    selectedModel,
    setSelectedModel,
    comparisonEnabled,
    onComparisonEnabledChange,
    hideCompare: t1,
    showGlobalModelSelector,
    allowAutoSelectProvider: t2,
    requiresProviderSelection: t3,
    mcpServers,
    onAddMcpServer,
    onUpdateMcpServer,
    onRemoveMcpServer,
    onToggleMcpServer,
    isTemporaryChat,
    onToggleTemporaryChat,
    showTemporaryChatSwitcher,
    isTemporaryChatToggleDisabled,
    hasTemporaryMessages,
    currentChatId,
    isShareChatDisabled: t4,
    showMcpServers: t5,
    showShareChat: t6,
    showComparisonMode: t7,
    showLanguageSelector: t8,
    shareId,
    orgShares,
    organizations,
    chatTitle,
    previewPrompt
  } = t0;
  const hideCompare = t1 === undefined ? false : t1;
  const allowAutoSelectProvider = t2 === undefined ? true : t2;
  const requiresProviderSelection = t3 === undefined ? false : t3;
  const isShareChatDisabled = t4 === undefined ? true : t4;
  const showMcpServers = t5 === undefined ? true : t5;
  const showShareChat = t6 === undefined ? true : t6;
  const showComparisonMode = t7 === undefined ? true : t7;
  const showLanguageSelector = t8 === undefined ? true : t8;
  let t9;
  if ($[0] !== isTemporaryChat) {
    t9 = isTemporaryChat ? null : <SidebarTrigger className="md:hidden" />;
    $[0] = isTemporaryChat;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  let t10;
  if ($[2] !== allowAutoSelectProvider || $[3] !== models || $[4] !== providers || $[5] !== requiresProviderSelection || $[6] !== selectedModel || $[7] !== setSelectedModel || $[8] !== showGlobalModelSelector) {
    t10 = showGlobalModelSelector ? <div className="w-full min-w-0 max-w-[360px] sm:max-w-[420px]"><ModelSelector models={models} providers={providers} value={selectedModel} onValueChange={setSelectedModel} placeholder="Search and select a model..." compactTrigger={true} allowAutoSelectProvider={allowAutoSelectProvider} requiresProviderSelection={requiresProviderSelection} /></div> : null;
    $[2] = allowAutoSelectProvider;
    $[3] = models;
    $[4] = providers;
    $[5] = requiresProviderSelection;
    $[6] = selectedModel;
    $[7] = setSelectedModel;
    $[8] = showGlobalModelSelector;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = <div className="flex min-w-0 flex-1 items-center gap-3">{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== hasTemporaryMessages || $[14] !== isTemporaryChat || $[15] !== isTemporaryChatToggleDisabled || $[16] !== onToggleTemporaryChat || $[17] !== showTemporaryChatSwitcher) {
    t12 = showTemporaryChatSwitcher ? <TempChatSwitcher isTemporaryChat={isTemporaryChat} onToggleTemporaryChat={onToggleTemporaryChat} isTemporaryChatToggleDisabled={isTemporaryChatToggleDisabled} hasTemporaryMessages={hasTemporaryMessages} /> : null;
    $[13] = hasTemporaryMessages;
    $[14] = isTemporaryChat;
    $[15] = isTemporaryChatToggleDisabled;
    $[16] = onToggleTemporaryChat;
    $[17] = showTemporaryChatSwitcher;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== chatTitle || $[20] !== comparisonEnabled || $[21] !== currentChatId || $[22] !== isShareChatDisabled || $[23] !== isTemporaryChat || $[24] !== orgShares || $[25] !== organizations || $[26] !== previewPrompt || $[27] !== shareId || $[28] !== showShareChat) {
    t13 = isTemporaryChat || !currentChatId || comparisonEnabled || !showShareChat ? null : <ShareChatDialog currentChatId={currentChatId} disabled={isShareChatDisabled} shareId={shareId} orgShares={orgShares} organizations={organizations} chatTitle={chatTitle} previewPrompt={previewPrompt} />;
    $[19] = chatTitle;
    $[20] = comparisonEnabled;
    $[21] = currentChatId;
    $[22] = isShareChatDisabled;
    $[23] = isTemporaryChat;
    $[24] = orgShares;
    $[25] = organizations;
    $[26] = previewPrompt;
    $[27] = shareId;
    $[28] = showShareChat;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== mcpServers || $[31] !== onAddMcpServer || $[32] !== onRemoveMcpServer || $[33] !== onToggleMcpServer || $[34] !== onUpdateMcpServer || $[35] !== showMcpServers) {
    t14 = showMcpServers ? <TooltipProvider><McpServersDialog servers={mcpServers} onAddServer={onAddMcpServer} onUpdateServer={onUpdateMcpServer} onRemoveServer={onRemoveMcpServer} onToggleServer={onToggleMcpServer} /></TooltipProvider> : null;
    $[30] = mcpServers;
    $[31] = onAddMcpServer;
    $[32] = onRemoveMcpServer;
    $[33] = onToggleMcpServer;
    $[34] = onUpdateMcpServer;
    $[35] = showMcpServers;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== comparisonEnabled || $[38] !== hideCompare || $[39] !== isTemporaryChat || $[40] !== onComparisonEnabledChange || $[41] !== showComparisonMode) {
    t15 = !showComparisonMode || isTemporaryChat ? null : !hideCompare || comparisonEnabled ? <div className="hidden items-center gap-2 md:flex">{hideCompare ? <span className="text-muted-foreground text-xs">Comparison mode</span> : <><Label htmlFor="comparison-mode" className="text-muted-foreground text-xs">Comparison mode</Label><Switch id="comparison-mode" checked={comparisonEnabled} onCheckedChange={onComparisonEnabledChange} /></>}</div> : null;
    $[37] = comparisonEnabled;
    $[38] = hideCompare;
    $[39] = isTemporaryChat;
    $[40] = onComparisonEnabledChange;
    $[41] = showComparisonMode;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== showLanguageSelector) {
    t16 = showLanguageSelector ? <LanguageSwitcher variant="code" /> : null;
    $[43] = showLanguageSelector;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t15 || $[49] !== t16) {
    t17 = <div className="ml-3 flex items-center gap-3">{t12}{t13}{t14}{t15}{t16}</div>;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t11 || $[52] !== t17) {
    t18 = <header className="bg-background flex h-16 items-center px-4">{t11}{t17}</header>;
    $[51] = t11;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  return t18;
};